import { dateAsStringToUtc } from '@/modules/transactionV2/util/vat'
import orgamax from 'ampersand-app'
import { transactionTypes } from '@/modules/base/util/constants'
import { TransactionBase } from '@/modules/transactionV2/models/TransactionBase'
const { TRANSACTION_TYPE_CLOSING_INVOICE } = transactionTypes

export const doVatAccountsMatchVatsForDate = (model, vatList) => {
  const allowedVatValues = vatList.map(({ value }) => value)
  const invoiceData = (model instanceof TransactionBase) ? model : model.toJSON()
  const notAllowedAccounts = Object.values(invoiceData.revenueAccounts).filter((account) => !allowedVatValues.includes(account.allowedVatRates.default))
  return notAllowedAccounts.length === 0
}

export const doVatPositionsMatchVatsForDate = (model, vatList) => {
  const allowedVatValues = vatList.map(({ value }) => value)
  const invoiceData = (model instanceof TransactionBase) ? model : model.toJSON()
  if (!invoiceData.positions) {
    return true
  }
  const notAllowedPos = Object.values(invoiceData.positions).filter((pos) => !allowedVatValues.includes(pos.vatPercent))
  return notAllowedPos.length === 0
}

export const areVatPositionOfSamePeriode = (model) => {
  const invoiceData = (model instanceof TransactionBase) ? model : model.toJSON()
  const positionsToCheck = invoiceData.positions.filter(pos => pos.vatPercent !== 0)
  if (positionsToCheck.length === 0) {
    return true
  }
  const lookupDate = orgamax.user.getVatList().find(vat => vat.value === positionsToCheck[0].vatPercent)?.dates[0].validFrom

  const vatPositionDateList = orgamax.user.getValidVatList(lookupDate)
  return doVatPositionsMatchVatsForDate(model, vatPositionDateList)
}

export const doDisplayModalBeforeSave = (model) => {
  const lookupDate = dateAsStringToUtc(model.getVatDate && model.getVatDate())

  const vatByCurrentDate = orgamax.user.getValidVatList(lookupDate)
  const isVatAT = vatByCurrentDate.some(item => (
    item.dates.some(date => date.countryCode === 'AT')
    && (item.value === 20 || item.value === 10)
  ))
  const vatPositionsDoesMatchDate = doVatPositionsMatchVatsForDate(model, vatByCurrentDate)
  let allowSaving = areVatPositionOfSamePeriode(model)
  let doDisplay = !vatPositionsDoesMatchDate // && user.allowVatNotification()
  // if Closing invoice allow mixed VATS saving but warn
  if (model.type === TRANSACTION_TYPE_CLOSING_INVOICE) {
    allowSaving = true
  }
  if (isVatAT) {
    allowSaving = true
    doDisplay = false
  }
  return { doDisplay, allowSaving }
}
